import React, { Component } from 'react';
import { Layout, Menu } from 'antd';
import { withRouter } from 'react-router';
import navs from '../Page/navs.config';
import '../Page/index.css';
import Icon from '../Icon';
import { getUser } from '../../utils/util';
import LoadSpan from '../LoadSpan';

const { Header, Content, Sider } = Layout;
const SubMenu = Menu.SubMenu;

class Loading extends Component {
    state = {
		rootPath: '',
        subPath: '',
        tPath:[''],
	}
    componentDidMount() {
        getUser();
        this.initPath(this.props);
    }
    initPath = (props) => {
        let [a, rootPath, subPath, tPath] = props.location.pathname.split('/');
		this.setState({ rootPath, subPath ,tPath: [tPath]});
    }
    renderMainNav = (allPermission, rootPath) => {
        return <Menu
            theme="dark"
            mode="horizontal"
            className="xrt-main-header-nav"
            style={{ lineHeight: '50px' }}
            selectedKeys={[rootPath]}
            onClick={this.handleNavMenuClick}
        >
            {
                navs.map((item)=> allPermission.find(i=>i.code === item.permissionName ) && <Menu.Item key={ item.key }>{ item.name }</Menu.Item> )
            }
        </Menu>
    }
    render() {
        const { rootPath, subPath } = this.state;
		const menus = navs.filter((menusItem) => menusItem.key === rootPath)[0] && navs.filter((menusItem) => menusItem.key === rootPath)[0].menus;
		if (!menus) {
			return null;
		}
		let allPermission = JSON.parse(sessionStorage.getItem('allPermission')) || [];
		let renderPermit = (path, item) => {
			if (item.childrenMenus) {
				item.childrenMenus.map((subItem) => {
					if (subItem.path === path) {
						if (!subItem.permissionName) {
							subItem.permit = true;
							return false;
						}
						allPermission.map((i) => {
							if (i.code == subItem.permissionName) {
								subItem.permit = true;
							}
						})
					}
				})
			} else {
				if (item.path === path) {
					//暂时没有指定权限的，显示
					if (!item.permissionName) {
						item.permit = true;
						return;
					}
					allPermission.map((i) => {
						if (i.code == item.permissionName) {
							item.permit = true;
						}
					})
				}
			}

		}
		menus.reduce((allKeys, rootItem) => {
			renderPermit(rootItem.path, rootItem);
			return allKeys;
        }, []);
        return (
            <Layout className="xrt-page" style={{ minHeight: '100vh' }}>
                <Header className="xrt-main-header">
                    <div className="xrt-main-title">汽车营销管理后台</div>
                    <div>
						{
							this.renderMainNav(allPermission, rootPath)
						}
                    </div>
                </Header>
                <Layout>
                    <Sider width={200} className={'xrt-left-nav'} style={{ background: '#2B2B38' }}>
                        <Menu
                            mode="inline"
                            theme={'light'}
                            style={{ height: '100%', borderRight: 0, }}
                        >
                            {
								menus.map((item, idx) => {
									return (
										<Menu.Item key={item.path} style={{ display: item.permit ? 'block' : 'none' }}>
											<Icon
												name={item.icon}
												color={'#1296db'}
												path={item.to}
												style={{ width: '20px', position: 'relative', top: '7px', left: '-5px' }}
											/>{item.name}
										</Menu.Item>
									)
								})
							}
                        </Menu>
                    </Sider>
                    <Layout style={{ padding: '0 0 0 10px' }}>
                        <Content style={{
                            background: '#eee', padding: 20, margin: 0, minHeight: 280,
                        }}
                        >
                            <LoadSpan />
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        )
    }
}

export default withRouter(Loading);


// WEBPACK FOOTER //
// ./src/components/Loading/index.jsx